export default {
  cancel: 'Отменить счет',
  saveAsTemplate: 'Сохранить как шаблон',
  messages: {
    stripeWarning:
      'Оплата с помощью платежной системы Stipe доступна только на '
  }
};
